import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";

const GOIFieldMultipleChoices = ({ value, inputData, disabled }) => {
  const { onInputValueChange } = useObjectInput();

  const { placeholder } = inputData.options;

  const options = inputData.options;

  const handleValueChange = (e) => {
    onInputValueChange(inputData.id, e.target.value);
  };

  return (
    <select
      value={value || ""}
      onChange={handleValueChange}
      disabled={disabled}
      className="goi-field-multiple-choices"
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {options.options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default GOIFieldMultipleChoices;
